import {useAuth} from '../../../context/authContext';
import UseGetProvince from '../../../utilities/hooks/province/useGetProvince';

const UseGetProfileCity = () => {
  const {user, isSupplier} = useAuth();
  const {provinces} = UseGetProvince();

  let selectedProvince;
  let profileCity;

  if (isSupplier) {
    selectedProvince = provinces?.find(
      item => item.id === user?.profile?.supplier_profile?.state,
    );

    profileCity =
      selectedProvince &&
      selectedProvince?.cities?.find(
        item => item.id === user?.profile?.supplier_profile?.city,
      )?.name;
  } else {
    selectedProvince = provinces?.find(
      item => item.id === user?.profile?.farmer_profile?.user_state,
    );

    profileCity =
      selectedProvince &&
      selectedProvince?.cities?.find(
        item => item.id === user?.profile?.farmer_profile?.user_city,
      )?.name;
  }

  return {profileCity, selectedProvince};
};

export default UseGetProfileCity;
